import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Reflection, ReflectionDto, ReflectionValue, ReflectionValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getReflection(id: string): Observable<Reflection> {
        return this.httpClient.get<ReflectionDto>(`reflections/${id}`).pipe(map((dto) => new Reflection(dto)));
    }

    createReflection(value: ReflectionValue): Observable<Reflection> {
        const dtoValue = new ReflectionValueDto(value);
        return this.httpClient.post<ReflectionDto>('reflections', dtoValue).pipe(map((dto) => new Reflection(dto)));
    }

    updateReflection(id: string, value: ReflectionValue): Observable<Reflection> {
        const dtoValue = new ReflectionValueDto(value);
        return this.httpClient.patch<ReflectionDto>(`reflections/${id}`, dtoValue).pipe(map((dto) => new Reflection(dto)));
    }

    deleteReflection(id: string): Observable<void> {
        return this.httpClient.delete<void>(`reflections/${id}`);
    }
}
